import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
require("./carousel.css");
var styles = {
  "wrapper": "wrapper-wzSG8",
  "wrapperReverse": "wrapperReverse-J3XPN",
  "dots": "dots-1WBPg",
  "dot": "dot-1cT4d",
  "dotInner": "dotInner-q7U0x",
  "dotActive": "dotActive-rhTPX",
  "carouselItem": "carouselItem-2lbap"
};
/**
 * Props injected by React-Multi-Carousel:
 * index
 * active
 * onClick
 * carouselState
 */
var Dot = _ref => {
  var {
    active,
    index,
    onClick,
    pagination,
    carouselState,
    className,
    totalItems
  } = _ref;
  if (carouselState.totalItems <= carouselState.slidesToShow) {
    return null;
  }
  var baseLabel = "slide ".concat(index + 1, " of ").concat(totalItems);
  var labelText = active ? "".concat(baseLabel, " (Current Slide)") : baseLabel;
  var content = pagination ? pagination[index] : /*#__PURE__*/React.createElement("span", {
    className: styles.dotInner
  });
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    "aria-label": labelText,
    className: cn(styles.dot, {
      [styles.dotActive]: active
    }, className),
    "data-testid": "carousel-dot",
    onClick: onClick,
    type: "button"
  }, content));
};
Dot.propTypes = {
  active: PropTypes.bool,
  carouselState: PropTypes.shape({
    slidesToShow: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired
  }).isRequired,
  index: PropTypes.number,
  onClick: PropTypes.func,
  pagination: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string,
  totalItems: PropTypes.number.isRequired
};
Dot.defaultProps = {
  active: false,
  carouselState: {
    totalItems: 0,
    slidesToShow: 0
  },
  index: 0,
  onClick: null,
  pagination: null,
  className: null
};
export default Dot;